// DS: C42
/** A sidebar that links to other related or recommended deviations */
import React, { Fragment } from 'react';
import classnames from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import ErrorBoundary from '../ErrorBoundary';
import LazyContext from '../LazyLoadingImage/LazyContext';
import { getSidebarSections, ABOVE_FOLD_SECTION_COUNT } from './helpers';
import SidebarSection from './SidebarSection';
import SidebarAd from './SidebarAd';
import s from './Sidebar.scss';
var Sidebar = function (_a) {
    var className = _a.className, deviation = _a.deviation;
    var sectionOrder = getSidebarSections(deviation);
    var isLoading = !deviation.extended;
    var adsIdx = 1;
    var sectionsToShow = isLoading
        ? sectionOrder.slice(0, ABOVE_FOLD_SECTION_COUNT)
        : sectionOrder;
    return (React.createElement(ErrorBoundary, { debugComponent: "Sidebar" },
        React.createElement(LazyContext.Provider, { value: true },
            React.createElement("div", { className: classnames(s['root'], className), role: "complementary" }, sectionsToShow.map(function (section, idx) { return (React.createElement(Fragment, { key: section },
                React.createElement(BiLoggerContextProvider, { key: section, value: { _rankOffset: 0 } },
                    React.createElement(SidebarSection, { type: section, deviation: deviation, isLoading: isLoading })),
                idx === adsIdx && React.createElement(SidebarAd, null))); })))));
};
Sidebar.displayName = 'Sidebar';
export default Sidebar;
//# sourceMappingURL=Sidebar.js.map